// Título (aba do navegador / Google) e descrição de cada página.
// Os posts do blog definem o próprio título (ver routes/blog/blog-post.component.jsx).
import { getInsurerBySlug } from './insurers.data';

const DEFAULT_DESCRIPTION =
  'Compare seguro viagem da Assist Card, Universal Assistance e Affinity em um só lugar. ' +
  'Veja preços e coberturas na hora, sem cadastro, e contrate em poucos minutos.';

const PAGES = {
  '/': {
    title: 'Assegurados | Compare e contrate seu seguro viagem online',
    description: DEFAULT_DESCRIPTION,
  },
  '/search-results': { title: 'Resultados da cotação | Assegurados' },
  '/comparar': { title: 'Comparar planos | Assegurados' },
  '/trip-ensurance': { title: 'Seguro viagem | Assegurados' },
  '/mult-trip': { title: 'Seguro viagem multiviagem | Assegurados' },
  '/sobre-nos': {
    title: 'Sobre nós | Assegurados',
    description:
      'Conheça a Assegurados, plataforma de cotação e compra de seguro viagem com as melhores seguradoras do mercado.',
  },
  '/duvidas': {
    title: 'Dúvidas frequentes sobre seguro viagem | Assegurados',
    description:
      'Tire suas dúvidas sobre seguro viagem: coberturas, Tratado de Schengen, como acionar o seguro e como comprar.',
  },
  '/blog': {
    title: 'Blog de viagem | Assegurados',
    description: 'Dicas de destinos, roteiros e tudo o que você precisa saber antes de viajar.',
  },
  '/termos-de-uso': { title: 'Termos de Uso | Assegurados' },
  '/politica-de-privacidade': { title: 'Política de Privacidade | Assegurados' },
  '/checkout': { title: 'Finalizar compra | Assegurados' },
  '/authentication': { title: 'Entrar | Assegurados' },
  '/registration': { title: 'Criar conta | Assegurados' },
  '/my-orders': { title: 'Meus pedidos | Assegurados' },
};

// Devolve { title, description } da página, ou null se ela cuida do próprio título.
export const getPageMeta = (pathname) => {
  const path = pathname.length > 1 ? pathname.replace(/\/$/, '') : pathname;

  if (path.startsWith('/blog/')) return null;

  if (path.startsWith('/seguradoras/')) {
    const insurer = getInsurerBySlug(path.split('/')[2]);
    if (insurer) {
      return {
        title: `Seguro viagem ${insurer.name}: coberturas e preços | Assegurados`,
        description: `Compare os planos de seguro viagem ${insurer.name} e contrate online. ${insurer.tagline}.`,
      };
    }
  }

  const page = PAGES[path] ?? { title: 'Assegurados | Seguro viagem' };
  return { description: DEFAULT_DESCRIPTION, ...page };
};
